import React from 'react';
import './FeatureGate.css';

const tierRank = { regular: 0, basic: 1, solo: 2, pro: 3 };

/**
 * Wraps a feature with subscription-based access control.
 * Shows greyed/disabled preview of feature with upgrade CTA below.
 *
 * @param {string} requiredTier - Minimum tier needed ('basic' | 'solo' | 'pro')
 * @param {string} currentTier - User's current subscription type
 * @param {string} title - Feature title for CTA (e.g., "Custom Domain")
 * @param {string} message - Benefit message explaining the feature
 * @param {function} onUpgradeClick - Callback to open payment modal
 * @param {boolean} blur - Whether to apply blur effect (default: false, just greyed)
 * @param {ReactNode} children - The feature UI to show as preview
 */
function FeatureGate({
  requiredTier,
  currentTier = 'regular',
  title,
  message,
  onUpgradeClick,
  blur = false,
  children
}) {
  const hasAccess = tierRank[currentTier] >= tierRank[requiredTier];

  if (hasAccess) {
    return children;
  }

  return (
    <div className="feature-gate">
      {/* Disabled preview of the feature */}
      <div className={`feature-gate-preview ${blur ? 'feature-gate-blur' : 'feature-gate-greyed'}`}>
        {children}
      </div>

      {/* CTA box below - horizontal layout with content left, button right */}
      <div className="regular-user-message-container feature-gate-cta-row">
        <div className="feature-gate-cta-content">
          <div className="regular-user-message-header">{title}</div>
          <div className="regular-user-message">{message}</div>
        </div>
        <button
          className="button-colored feature-gate-upgrade-btn"
          onClick={onUpgradeClick}
        >
          Upgrade now
        </button>
      </div>
    </div>
  );
}

export default FeatureGate;
